angular.module('zc.projects')
  .component('zcCampaignSummary', {
    templateUrl: '/templates/projects.campaigns/components/campaign_summary.html',
    bindings: {
      campaigns: '<',
      filters: '<',
      isAb: '<',
      showHiddenAb: '<',
      project: '<',
    },
    controller: campaignSummary,
    controllerAs: 'vm'
  });

campaignSummary.$inject = ['$filter', '$scope', 'AccessStats', 'CampaignStats', 'currencies', 'Devise'];
function campaignSummary($filter, $scope, AccessStats, CampaignStats, currencies, Devise) {
  const vm = this;

  vm.currency = currencies[vm.project.currency];
  vm.Devise = Devise;

  vm.$onInit = () => vm.updateData();

  vm.updateData = () => {
    vm.getCampaignStats().then(() => {
      vm.siteSessionCount = 0;
      vm.totalDeliveryCount = _.sumBy(
        vm.campaigns,
        'stats.experimental.delivery_count'
      );
      vm.totalConversionCount = _.sumBy(
        vm.campaigns,
        'stats.experimental.conversion_count'
      );
      const couponCodeCampaigns = _.filter(vm.campaigns, campaign => {
        const currentIncentive = campaign.current_incentive;
        return currentIncentive && ['coupon_code', 'unique_coupon_code'].includes(currentIncentive.incentive_type);
      });
      const campaignCouponCodeUsedCount = _.sumBy(
        couponCodeCampaigns,
        'stats.experimental.campaign_coupon_used_count'
      );
      const couponCodeCampaignsTotalConversionCount = _.sumBy(
        couponCodeCampaigns,
        'stats.experimental.conversion_count'
      );
      if(couponCodeCampaignsTotalConversionCount > 0 && campaignCouponCodeUsedCount > 0) {
        vm.totalCouponUsedRate = $filter('number')(campaignCouponCodeUsedCount / couponCodeCampaignsTotalConversionCount * 100, 2);
      } else {
        vm.totalCouponUsedRate = '- '; // display - % when no coupon code used count stat
      }

      const nonAovCampaigns = _.filter(vm.campaigns, { is_aov_campaign: false });
      vm.totalConversionValue = _.sumBy(
        nonAovCampaigns,
        'stats.experimental.conversion_price'
      );
      vm.conversion_up_rate = $filter('overallCampaignCvrIncreaseRate')(nonAovCampaigns, vm.showHiddenAb);

      const abTestCampaigns = _.reject(vm.campaigns, { campaign_control_percent: 0 });
      vm.totalRevenueGrowth = _.sumBy(
        abTestCampaigns,
        'stats.contribution_price'
      );

      AccessStats.aggregateByFilter({
        apikey: vm.project.apikey,
        dimension: 'daily'
      }, vm.filters)
        .then(function(accessStats) {
          vm.siteSessionCount = accessStats[0].session_count;
        });
    });
  };

  vm.getCampaignStats = () => {
    if(vm.campaigns.length === 0) return Promise.resolve();

    return CampaignStats.aggregate({
      dimension: 'daily',
      apikey: vm.project.apikey,
      campaign_ids: _.map(vm.campaigns, 'id'),
      start_at: vm.filters.start_at,
      end_at: vm.filters.end_at
    }).then(campaignStats => {
      const statsById = CampaignStats.groupById(campaignStats);
      _.each(vm.campaigns, campaign => {
        campaign.stats = statsById[campaign.id];
        const calculatedInvoiceAmount = CampaignStats.calculateInvoiceAmount(vm.project, campaign, campaign.stats);
        _.assign(campaign.stats, {
          invoice_amount: calculatedInvoiceAmount
        });
      });
    });
  };

  $scope.$watch('vm.filters', vm.updateData, true);
  $scope.$watch('vm.campaigns', vm.updateData, true);
  $scope.$watch('vm.showHiddenAb', vm.updateData, true);
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/components/campaign_summary.js